import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { VIDEOS } from "@/lib/images";

const FILMS = [
  {
    id: "teach-me-to-love",
    title: "Teach Me to Love",
    src: VIDEOS.teachMeToLove,
    poster: "/images/teach-me-to-love-poster.jpg",
    featured: true,
  },
  {
    id: "i-want-to-know-christ",
    title: "I Want to Know Christ",
    src: VIDEOS.iWantToKnowChrist,
    poster: "/images/i-want-to-know-christ-poster.jpg",
  },
  {
    id: "praise-medley",
    title: "Praise Medley",
    src: VIDEOS.praiseMedley,
    poster: "/images/praise-medley-poster.jpg",
  },
  {
    id: "o-holy-night",
    title: "O Holy Night",
    src: VIDEOS.oHolyNight,
    poster: "/images/o-holy-night-poster.jpg",
    tag: "Christmas Performance",
  },
  {
    id: "more-than-wonderful",
    title: "More Than Wonderful",
    src: VIDEOS.moreThanWonderful,
    poster: "/images/more-than-wonderful-poster.jpg",
  },
];

const FilmCard = ({ film, delay = 0 }) => (
  <Reveal delay={delay} className={film.featured ? "md:col-span-2" : ""}>
    <article data-testid={`video-${film.id}`}>
      <div
        className={`relative overflow-hidden border ${
          film.featured ? "border-gold/25" : "border-white/[0.08]"
        }`}
      >
        <video
          src={film.src}
          poster={film.poster}
          controls
          preload="metadata"
          className="aspect-video w-full bg-charcoal-900 object-cover"
          data-testid={`video-player-${film.id}`}
        />
      </div>
      <div className="mt-4 flex items-baseline justify-between">
        <h2 className={`font-serif font-light text-sand-bright ${film.featured ? "text-2xl" : "text-xl"}`}>
          {film.title}
        </h2>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
          {film.tag || "Performance Film"}
        </span>
      </div>
    </article>
  </Reveal>
);

export default function Videos() {
  return (
    <>
      <Seo
        title="Live Performances — Derrick Hall"
        siteName="Derrick Hall"
        description="Watch Derrick Hall perform Christian and inspirational music in intimate, faith-centered settings."
      />
      <PageHeader
        testId="videos-header"
        eyebrow="Watch"
        title="Live Performances"
        description="Watch Derrick Hall perform Christian and inspirational music in intimate, faith-centered settings."
      />
      <div className="mx-auto max-w-7xl px-6 pb-28" data-testid="video-gallery">
        <div className="grid gap-10 md:grid-cols-2">
          {FILMS.map((f, i) => (
            <FilmCard key={f.id} film={f} delay={0.08 * i} />
          ))}
        </div>
      </div>
    </>
  );
}
